import { ColumnDef } from "@tanstack/react-table";

import { Checkins2 } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";
import { BreaksCell } from "./breaks-cell";
// import { Badge } from "@/components/ui/badge/badge";

export const columns: ColumnDef<Checkins2, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "employee",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Employee" />
    ),
    cell: ({ row }) => <div>{row.getValue("employee")}</div>,
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "checkinTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Checkin Time" />
    ),
    cell: ({ row }) => <div>{row.getValue("checkinTime")}</div>,
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "checkoutTime",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Checkout Time" />
    ),
    cell: ({ row }) => <div>{row.getValue("checkoutTime")}</div>,
    enableColumnFilter: true,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "breaks",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Breaks" />
    ),
    cell: ({ row }) => <BreaksCell breaks={row.original.breaks ?? []} />,
    enableSorting: false,
    enableHiding: false,
  },
  // {
  //   accessorKey: "totalWorkedHours",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Total worked hours" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("totalWorkedHours")}</div>,
  //   enableColumnFilter: true,
  //   enableSorting: false,
  //   enableHiding: false,
  // },
  // {
  //   accessorKey: "status",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Status" />
  //   ),
  //   cell: ({ row }) => {
  //     const bgColors = {
  //       "Full Day": "#2563eb",
  //       "Half Day": "white",
  //       "Not Counting": "#e11d48",
  //       "Still Working": "#22c55e",
  //     };

  //     const textColors = {
  //       "Full Day": "white",
  //       "Half Day": "white",
  //       "Not Counting": "white",
  //       "Still Working": "white",
  //     };

  //     return (
  //       <div>
  //         <Badge
  //           style={{
  //             backgroundColor: `${
  //               bgColors[
  //                 row.getValue("status") as
  //                   | "Full Day"
  //                   | "Half Day"
  //                   | "Not Counting"
  //               ]
  //             }`,

  //             color: `${
  //               textColors[
  //                 row.getValue("status") as
  //                   | "Full Day"
  //                   | "Half Day"
  //                   | "Not Counting"
  //               ]
  //             }`,
  //           }}
  //         >
  //           {row.getValue("status")}
  //         </Badge>
  //       </div>
  //     );
  //   },
  //   enableColumnFilter: true,
  //   enableSorting: false,
  //   enableHiding: false,
  // },
];
